import { render, staticRenderFns } from "./CabinetLayout.vue?vue&type=template&id=2d119eb0"
import script from "./CabinetLayout.vue?vue&type=script&lang=ts"
export * from "./CabinetLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports